import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MxIpService {
  constructor(private http: HttpClient) {}

  public getIPAddress(): Observable<{ ip: string }> {
    return this.http.get<{ ip: string }>('https://api.ipify.org/?format=json');
  }
}
